import { useState } from 'react';
import { getShimmerDataURL } from '../../utils/imageUtils';

interface BackgroundItemCardProps {
  item: any;
}

export function BackgroundItemCard({ item }: BackgroundItemCardProps) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  // Priority: highlighted image > cached_image_url > first cached image in array > placeholder
  const highlightedImage = item.images?.find((img: any) => img.highlighted);
  const cachedImageUrl = highlightedImage?.cached_url ||
                         item.cached_image_url ||
                         item.cached_image ||
                         item.images?.[0]?.cached_url;

  return (
    <div
      className="relative bg-white overflow-hidden"
      style={{
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
      }}
    >
      {/* Image Container */}
      <div className="relative">
        {!cachedImageUrl ? (
          <div className="w-full h-48 bg-gray-100 flex items-center justify-center">
            <span className="text-gray-400 text-sm">Image pending</span>
          </div>
        ) : (
          <>
            {/* Blur-up placeholder */}
            {!imageLoaded && !imageError && (
              <div className="relative w-full" style={{ paddingBottom: '100%' }}>
                <img
                  src={getShimmerDataURL()}
                  alt=""
                  className="absolute inset-0 w-full h-full object-cover"
                  style={{
                    filter: 'blur(20px)',
                    transform: 'scale(1.1)',
                  }}
                />
              </div>
            )}

            {!imageError ? (
              <img
                src={cachedImageUrl}
                alt={item.title}
                className={`w-full h-auto object-cover transition-all duration-500 ease-out ${
                  imageLoaded ? 'opacity-100' : 'opacity-0 absolute inset-0'
                }`}
                loading="lazy"
                style={{ display: 'block' }}
                onLoad={() => setImageLoaded(true)}
                onError={() => {
                  setImageError(true);
                  setImageLoaded(true);
                }}
              />
            ) : (
              <div className="w-full h-48 bg-gray-100" />
            )}
          </>
        )}
      </div>

      {/* Content - simplified */}
      <div className="p-3">
        <h3 className="text-sm text-gray-700 line-clamp-2" style={{ fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif", fontWeight: 400 }}>
          {item.title}
        </h3>
        {item.brand && (
          <p className="text-xs text-gray-500 mt-1" style={{ fontFamily: "'GT America Mono', 'Courier New', monospace" }}>
            {item.brand}
          </p>
        )}
      </div>
    </div>
  );
}
